/** @jsxImportSource @emotion/react */
import React from 'react';
import { Form, InputNumber } from 'antd';
import { useTranslation } from 'react-i18next';
import commonStyles from '../../../../../styles/commonStyles';

/** Quantity fields. Lifecycle completion is handled by explicit disposition actions. */
const BasicFieldsSection: React.FC = () => {
  const { t } = useTranslation('plantings');
  return (
  <>
    <Form.Item
      label={t('add.plantCount')}
      name="quantity"
      tooltip={t('form.quantityTooltip')}
      rules={[
        { required: true, message: t('disposition.quantityRequired') },
        { type: 'number', min: 1, message: t('form.quantityPositive') },
      ]}
      initialValue={1}
    >
      <InputNumber
        min={1}
        step={1}
        placeholder={t('add.plantCount')}
        css={commonStyles.fullWidth}
        addonAfter={t('units.pcs')}
      />
    </Form.Item>

  </>
  );
};

export default BasicFieldsSection;
